/*
 * Dreamy — estimation de livraison (S5).
 * Fourchette = jour de la commande (heure de Paris) + shipping_min_days / shipping_max_days jours de livraison,
 * en sautant les dimanches et les jours fériés français 2026-2028 (dont lundi de Pâques, Ascension,
 * lundi de Pentecôte). Le samedi compte. Pas d'heure limite.
 * Les fonctions sont pures et testées (tests/delivery-estimate.test.mjs).
 */
(function (root) {
  var D = (root.Dreamy = root.Dreamy || {});

  var HOLIDAYS = [
    // 2026
    '2026-01-01', '2026-04-06', '2026-05-01', '2026-05-08', '2026-05-14', '2026-05-25',
    '2026-07-14', '2026-08-15', '2026-11-01', '2026-11-11', '2026-12-25',
    // 2027
    '2027-01-01', '2027-03-29', '2027-05-01', '2027-05-06', '2027-05-08', '2027-05-17',
    '2027-07-14', '2027-08-15', '2027-11-01', '2027-11-11', '2027-12-25',
    // 2028
    '2028-01-01', '2028-04-17', '2028-05-01', '2028-05-08', '2028-05-25', '2028-06-05',
    '2028-07-14', '2028-08-15', '2028-11-01', '2028-11-11', '2028-12-25',
  ];

  /* Les dates sont manipulées en UTC minuit pour représenter un jour civil de Paris. */
  function key(d) {
    return d.toISOString().slice(0, 10);
  }
  /* Jour de livraison : tous les jours sauf le dimanche et les jours fériés. */
  function isDeliveryDay(d) {
    return d.getUTCDay() !== 0 && HOLIDAYS.indexOf(key(d)) === -1;
  }
  function nextDeliveryDay(d) {
    var x = new Date(d.getTime());
    do {
      x.setUTCDate(x.getUTCDate() + 1);
    } while (!isDeliveryDay(x));
    return x;
  }
  function addDeliveryDays(d, n) {
    var x = new Date(d.getTime());
    for (var i = 0; i < n; i++) x = nextDeliveryDay(x);
    return x;
  }

  /* Jour civil et heure à Paris pour un instant donné. */
  function parisParts(now) {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Paris',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(now);
    var get = function (t) {
      for (var i = 0; i < parts.length; i++) if (parts[i].type === t) return parseInt(parts[i].value, 10);
      return 0;
    };
    return { day: new Date(Date.UTC(get('year'), get('month') - 1, get('day'))), hour: get('hour') };
  }

  function estimate(now, opts) {
    var o = opts || {};
    var min = o.min == null ? 3 : o.min;
    var max = o.max == null ? 6 : o.max;
    var start = parisParts(now).day;
    return { order: start, from: addDeliveryDays(start, min), to: addDeliveryDays(start, Math.max(min, max)) };
  }

  /* « mar. 6 oct. » */
  function formatDay(d) {
    return d.toLocaleDateString('fr-FR', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' });
  }

  function sentence(now, opts, template) {
    var e = estimate(now, opts);
    return (template || 'Livraison estimée entre le {from} et le {to}').replace('{from}', formatDay(e.from)).replace('{to}', formatDay(e.to));
  }

  D.delivery = {
    HOLIDAYS: HOLIDAYS,
    isDeliveryDay: isDeliveryDay,
    nextDeliveryDay: nextDeliveryDay,
    addDeliveryDays: addDeliveryDays,
    parisParts: parisParts,
    estimate: estimate,
    formatDay: formatDay,
    sentence: sentence,
  };

  if (typeof document === 'undefined') return;
  function init() {
    var els = document.querySelectorAll('[data-dreamy-delivery]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var opts = {
        min: parseInt(el.getAttribute('data-min'), 10),
        max: parseInt(el.getAttribute('data-max'), 10),
      };
      if (isNaN(opts.min)) opts.min = 3;
      if (isNaN(opts.max)) opts.max = 6;
      try {
        el.textContent = sentence(new Date(), opts, el.getAttribute('data-template'));
        el.hidden = false;
      } catch (e) {
        el.hidden = true;
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})(typeof window !== 'undefined' ? window : globalThis);
